// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header-3urPGbjq","user":"user-3wzFIw3M"};